/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import React from 'react';
import PropTypes from 'prop-types';
import { formatTime } from '../../../../../../javascript/time_formatting';
import * as Utilities from '../../utilities';
import { FormInputGroup } from '../../../react/form_input_group.jsx';
import { FormRow } from '../../../react/form_row.jsx';

export class TicketPreviewList extends React.Component {
        constructor(...args) {
          super(...args);
this.renderTicketGroup = this.renderTicketGroup.bind(this);
        }

        static initClass() {
          this.propTypes =
            {ticketGroups: PropTypes.array};
  
          this.defaultProps =
            {ticketGroups: []};
        }

        render() {
          const rows = (() => {
            const result = [];
            for (const item of Array.from(this.props.ticket_class_groups)) {
              const group = item[0];
              const ticket_classes = item[1];

              result.push(this.renderTicketGroup(group, ticket_classes));
            }
            return result;
          })();

          return           <div className="widget-content">
  <form className="form_box form-sidebar">
            {rows}
          </form></div>;
        }

        renderTicketGroup(group, ticket_classes) {
          let header;
          const my = this;
          const {
            currency
          } = this.props;

          if (group) {
            header = <FormInputGroup className="ticket-group-header"><FormRow title={group.name} /></FormInputGroup>;
          } else {
            header = null;
          }

          const rows = (() => {
            const result = [];
            for (const ticket_class of Array.from(ticket_classes)) {
              const amount = ticket_class.donation ?
                (ticket_class.min_price > 0) && (ticket_class.max_price > 0) ?
                  `${Utilities.formatCurrency(ticket_class.min_price, currency)  } - ${  Utilities.formatCurrency(ticket_class.max_price, currency)}`
                : ticket_class.max_price > 0 ?
                  `MAX ${  Utilities.formatCurrency(ticket_class.max_price, currency)}`
                :
                  `${Utilities.formatCurrency(ticket_class.min_price, currency)  } +`
              :
                ticket_class.price === 0 ? 'Free' : Utilities.formatCurrency(ticket_class.price, currency);

              result.push(<label className="ticket_class" key={ticket_class.id}>
                <span className="leftside">{ticket_class.name}</span>
                <span className="rightside ticket_price">
                  {amount}
                </span>

                <div className="leftside">
                  {ticket_class.description && (<p className="ticket_description">{ticket_class.description}</p>)}
                  {ticket_class.not_yet_available && <p className="ticket_notes">Available Starting {my._formatDateTime(ticket_class.availability_start)}</p>}
                  {ticket_class.no_longer_available && <p className="ticket_notes">Sales Ended {my._formatDateTime(ticket_class.availability_finish)}</p>}
                  {ticket_class.available_now && ticket_class.availability_finish && <p className="ticket_notes">On Sale Until {my._formatDateTime(ticket_class.availability_finish)}</p>}
                </div>
              </label>);
            }
            return result;
          })();

          return <div key={group ? group.id : 'default'}>
            {header}

            <FormInputGroup className="ticket-group-wrap">
              {rows}
            </FormInputGroup>
          </div>;
        }

        _formatDateTime(time) {
          const date = new Date(time);
          return formatTime(date, null, 'detailed');
        }
      }
TicketPreviewList.initClass();